// Chart Colors - Using pastel colors for pleasant visual experience
export const CHART_COLORS = {
  primary: "#91c7f7",      // Pastel Blue - Primary actions, Applied
  success: "#95de64",      // Pastel Green - Success, Qualified, Hired
  warning: "#ffc069",      // Pastel Orange - Warning, Pending
  error: "#ff7875",        // Pastel Red - Error, Rejected, Unqualified
  info: "#87e8de",         // Pastel Cyan - Info, Qualified (alternative)
  purple: "#b37feb",       // Pastel Purple - Shortlisted, Secondary
  placeholder: "#d9d9d9",  // Grey - Placeholder/disabled state
  // Funnel stage colors
  interview: "#ffa940",    // Orange - Interview stage
  hired: "#52c41a",        // Bright Green - Hired (final success)
  assessmentCompleted: "#36cfc9", // Teal - Assessment completed
  resumeUploaded: "#69b1ff", // Light Blue - Resume uploaded
} as const;

// Source chart colors (for pie/donut charts)
export const SOURCE_COLORS = [
  "#91c7f7",  // Blue - Candidate
  "#95de64",  // Green - Company
  "#b37feb",  // Purple - Lever
  "#ffc069",  // Orange - Zoho
  "#ff85c0",  // Pink - Custom
  "#87e8de",  // Cyan - Other
] as const;

// Date filter type options
export type DateFilterType = 
  | "today" 
  | "last7days" 
  | "last30days" 
  | "last90days" 
  | "allTime"
  | "custom";

